import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface IMarketAwardSourceFilterSelectProps {
    value: string[] | undefined;
    onChange: (value: string[]) => void;
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    options: ISelectOption<string>[];
}

export const MarketAwardSourceFilterSelect: React.FC<IMarketAwardSourceFilterSelectProps> = ({
    value = [],
    onChange,
    label,
    height = 120,
    disabled = false,
    options,
}) => {
    return (
        <BaseFilterCheckboxSelect
            resizable={false}
            showClear={false}
            multiple
            searchable={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            height={height}
        />
    );
};
